import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { CalendarProps } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './StorageUnitsDateFilter.scss';
import ModalDatePicker from '../../../../../../Caja/Receipts/components/Filters/components/ModalDatePicker/ModalDatePicker';

interface StorageUnitsDateFilterProps {
  startDate: string;
  setStartDate: (startDate: string) => void;
  endDate: string;
  setEndDate: (endDate: string) => void;
}

const StorageUnitsDateFilter: React.FC<StorageUnitsDateFilterProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate
}) => {
  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);

  // Convierte el string a Date o null (soporta YYYY-MM-DD y YYYY-MM-DDTHH:mm:ss)
  const parseDateString = (str: string) => {
    if (!str) return null;
    // Si ya tiene hora, pásalo directo
    if (str.includes('T')) return new Date(str);
    // Si no, agrégale T00:00:00
    return new Date(`${str}T00:00:00`);
  };
  
  const startDateObj = parseDateString(startDate);
  const endDateObj = parseDateString(endDate);

  // Formatea para mostrar al usuario (DD-MM-YYYY)
  const formatDisplayDate = (date: Date): string => {
    const year  = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day   = date.getDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  };

  // Formatea para guardar en el estado (YYYY-MM-DD)
  const formatStateDate = (date: Date): string => {
    const year  = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day   = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleStartDateChange: CalendarProps['onChange'] = (value) => {
    const date = Array.isArray(value) ? value[0] : value;
    if (date) {
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const formatted = formatStateDate(localDate);
      setStartDate(formatted);
    }
  };

  const handleEndDateChange: CalendarProps['onChange'] = (value) => {
    const date = Array.isArray(value) ? value[0] : value;
    if (date) {
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const formatted = formatStateDate(localDate);
      setEndDate(formatted);
    }
  };

  return (
    <div className="storage-units-date-filter-container">
      <div className="storage-date-filter">
        <Form.Group controlId="startDate" className='mp-formgroup horizontal storage'>
          <Form.Label>Fecha Inicio</Form.Label>
          <Button
            variant="none"
            onClick={() => setShowStartCalendar(true)}
            className="boton-show-calendar-storage"
          >
            {startDateObj
              ? formatDisplayDate(startDateObj)
              : 'Seleccionar fecha'}
          </Button>
        </Form.Group>
      </div>

      <div className="storage-date-filter">
        <Form.Group controlId="endDate" className='mp-formgroup horizontal storage'>
          <Form.Label>Fecha Fin</Form.Label>
          <Button
            variant="none"
            onClick={() => setShowEndCalendar(true)}
            className="boton-show-calendar-storage"
          >
            {endDateObj
              ? formatDisplayDate(endDateObj)
              : 'Seleccionar fecha'}
          </Button>
        </Form.Group>
      </div>

      {/* Modal para fecha de inicio */}
      <ModalDatePicker
        show={showStartCalendar}
        onHide={() => setShowStartCalendar(false)}
        title="Seleccionar Fecha de Inicio"
        value={startDateObj}
        onChange={handleStartDateChange}
        maxDate={endDateObj || undefined}
      />

      {/* Modal para fecha de fin */}
      <ModalDatePicker
        show={showEndCalendar}
        onHide={() => setShowEndCalendar(false)}
        title="Seleccionar Fecha de Fin"
        value={endDateObj}
        onChange={handleEndDateChange}
        minDate={startDateObj || undefined}
      />
    </div>
  );
};

export default StorageUnitsDateFilter;
